export default __webpack_public_path__ + "static/media/md8-production-execution.e0da6e03.svg";